// extracted by mini-css-extract-plugin
module.exports = {"container":"V52uKMJWwDLdGbmR7RtP1"};